// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ValidationMethods-module-verificationImage-w2pz7{display:block;height:auto;margin-top:24px;margin-bottom:20px;width:100%}.ValidationMethods-module-formContainer-41_x1{margin-bottom:40px}.ValidationMethods-module-methodsRow-1ZxoF{display:flex;flex-wrap:wrap}.ValidationMethods-module-identificationLabelContainer-3ZDzV{margin-top:20px;margin-bottom:10px}.ValidationMethods-module-actionContainer-K_CBf{display:flex;justify-content:center;margin-top:30px}.ValidationMethods-module-methodsTitle-1iSbu{color:#5c615e}", ""]);
// Exports
exports.locals = {
	"verificationImage": "ValidationMethods-module-verificationImage-w2pz7",
	"formContainer": "ValidationMethods-module-formContainer-41_x1",
	"methodsRow": "ValidationMethods-module-methodsRow-1ZxoF",
	"identificationLabelContainer": "ValidationMethods-module-identificationLabelContainer-3ZDzV",
	"actionContainer": "ValidationMethods-module-actionContainer-K_CBf",
	"methodsTitle": "ValidationMethods-module-methodsTitle-1iSbu"
};
module.exports = exports;
